/*
 * @Author: Tina Huang
 * @Date: 2024-02-23 13:59:37
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-10-23 15:00:21
 * @Description:
 */
import { VipPlans, VipFolderPlans } from '@/constants/vips'
import { ArrowRightOutlined, CheckCircleOutlined, EyeOutlined } from '@ant-design/icons'
import { Card, Flex, Image, Avatar, Button, QRCode, Modal, Divider, Tag, Alert, Badge, Drawer, Row, Col } from 'antd'
import Author from '@/components/Author'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Picks } from '@/constants/picks'
import wechatQrcode from '@/assets/qrcodes/wechat.jpg'
// import SpaceByType from './SpaceByType'
// import styles from './index.module.css'

const BuyCode = () => {
  return <QRCode className="m-auto" errorLevel="H" value="https://item.taobao.com/item.htm?ft=t&id=722601465247" />
}

const VipItem = (props: { item: any; onBuyVip: any }) => {
  const { item, onBuyVip } = props
  const isMobile = window.innerWidth <= 750

  const realPrice = item?.price - item?.off

  const handleVip = () => {
    // window?.splitbee?.track('Be Vip', { type: item?.type })
    onBuyVip?.()
  }

  return (
    <Card hoverable className={`${isMobile ? 'w-full mb-2' : 'w-80 mb-8'} vip-item`}>
      <Card.Meta
        title={
          <div className={`flex items-center text-center text-xl`}>
            <Avatar.Group className="p-4 text-center">
              {item?.logos.map((logo: string) => (
                <Avatar className="w-12 h-12" key={item.type} src={logo} />
              ))}
            </Avatar.Group>
            {item.title}
          </div>
        }
        description={
          <>
            <div className={isMobile ? 'flex justify-between items-center' : ''}>
              <h2 className="text-5xl text-center my-5 text-rose-700 flex items-center justify-center">
                ¥ {realPrice}
                {item?.off > 0 && <small className={`text-neutral-400 text-2xl line-through ml-2`}>¥ {item?.price}</small>}
              </h2>
              <Button
                type="primary"
                shape="round"
                size="large"
                block={!isMobile}
                className={[isMobile ? 'my-2' : 'my-3.5'].join(' ')}
                onClick={handleVip}
              >
                👑 我要订阅
              </Button>
            </div>
            {!isMobile && (
              <div>
                {item?.rights.map((right: string) => (
                  <p key={`${item?.type}-${right}`} className="leading-8">
                    <CheckCircleOutlined className="mr-2 text-teal-600" />
                    {right}
                  </p>
                ))}
              </div>
            )}
            {item?.desc && (isMobile ? item.type !== 'all' : true) && (
              <>
                <Divider>更新说明</Divider>
                {item?.desc.map((ss: string) => (
                  <li className="leading-8">{ss}</li>
                ))}
              </>
            )}
            {item?.activity && (
              <>
                <Divider>
                  <Tag color="red">❗️限时活动</Tag>
                </Divider>
                <p className="pt-4 font-bold text-red-800">{item?.activity}</p>
              </>
            )}
          </>
        }
      />
    </Card>
  )
}

const VipItemNew = (props: { item: any; onBuyVip: any }) => {
  const { item, onBuyVip } = props
  const isMobile = window.innerWidth <= 750

  const realPrice = item?.price - item?.off

  const handleVip = () => {
    // window?.splitbee?.track('Be Vip', { type: item?.type })
    onBuyVip?.()
  }
  return (
    <div>
      <Card hoverable className="w-full mb-2">
        <div className="flex w-full">
          <div className="w-2/5">
            <div className={`flex items-center text-center text-xl`}>
              <Avatar.Group className="p-4 text-center">
                {item?.logos.map((logo: string) => (
                  <Avatar className="w-12 h-12" key={item.type} src={logo} />
                ))}
              </Avatar.Group>
              {item.title}
            </div>
            <h2 className="text-5xl my-5 text-rose-700 flex items-center pl-4">
              ¥ {realPrice}
              {item?.off > 0 && <small className={`text-neutral-400 text-2xl line-through ml-2`}>¥ {item?.price}</small>}
            </h2>
          </div>
          <div className="mr-8 w-1/4">
            <Button
              type="primary"
              shape="round"
              size="large"
              block={!isMobile}
              className={[isMobile ? 'my-2' : 'my-3.5'].join(' ')}
              onClick={handleVip}
            >
              👑 我要订阅
            </Button>
            {item?.desc && (isMobile ? item.type !== 'all' : true) && (
              <>
                <Divider>更新说明</Divider>
                {item?.desc.map((ss: string) => (
                  <li className="leading-8">{ss}</li>
                ))}
              </>
            )}
          </div>
          <div>
            {item?.rights.map((right: string) => (
              <p key={`${item?.type}-${right}`} className="leading-8">
                <CheckCircleOutlined className="mr-2 text-teal-600" />
                {right}
              </p>
            ))}
            {item?.activity && (
              <>
                <Divider>
                  <Tag color="red">❗️限时活动</Tag>
                </Divider>
                <p className="pt-4 font-bold text-red-800">{item?.activity}</p>
              </>
            )}
          </div>
        </div>
      </Card>
    </div>
  )
}

export default function Vips() {
  const isMobile = window.innerWidth <= 750
  const [showQRCode, setShowQRCode] = useState(false)
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [activeFolder, setActiveFolder] = useState<any>(null)
  const [openTemplate, setOpenTemplate] = useState(false)
  const [activeTemplate, setActiveTemplate] = useState<any>(null)

  const flexProps = isMobile
    ? {
        vertical: true,
        justify: 'center',
        className: 'w-full',
      }
    : { justify: 'space-between', className: 'w-full m-auto' }

  const handleBuyVip = (item: any) => {
    if (item.path) return navigate(item?.path)
    return setShowQRCode(true)
    if (isMobile) {
      window.open('https://item.taobao.com/item.htm?ft=t&id=722601465247')
    } else setShowQRCode(true)
  }

  const handleShowFolderDetail = (item: any) => {
    setActiveFolder(item)
    if (item.templates.length <= 0 || item.templates?.[0] === 0) return
    setOpen(true)
  }

  const handleTemplateDetail = (id: number) => {
    navigate(`/picks-detail/${id}`)
  }

  const templatesList = useMemo(() => {
    // fetch templates in folder
    const _templates = activeFolder?.templates || []
    return _templates?.map((id: number) => Picks.find((item) => item.id === id))
  }, [activeFolder])

  const handleActiveTemplate = (item: any) => {
    setOpenTemplate(true)
    setActiveTemplate(item)
  }

  return (
    // <Spin tip={<h2 className="font-bold text-xl">会员机制正在升级中……</h2>}>
    <div>
      <h1 className="text-4xl text-center mb-10 font-bold">✨ 模板订阅 ✨</h1>
      <Flex {...flexProps}>
        <div className={isMobile ? 'w-full' : 'w-3/4 mr-4'}>
          {VipPlans.map((item) =>
            isMobile ? (
              <VipItem item={item} key={item.type} onBuyVip={() => handleBuyVip(item)} />
            ) : (
              <VipItemNew item={item} key={item.type} onBuyVip={() => handleBuyVip(item)} />
            )
          )}
          {false && (
            <Badge.Ribbon text="分期订阅">
              <div className="w-full mb-2 bg-white rounded-lg shadow-sm p-4">
                <h1 className="text-2xl font-bold">
                  知识库订阅「Notion」
                  <small className="text-gray-400 text-sm pl-4"> 分类模版库，为只需要指定类型模版的小伙伴提供不同知识库订阅</small>
                </h1>
                <p className="pt-2">
                  该知识库订阅将使用<strong>分期订阅</strong>
                  的形式，可根据需要选择不同期进行订阅（<strong>每期不少于8个模版，无使用时长限制</strong>），
                  <span className="text-rose-800 font-bold">可以点击相关卡片查看内容详情</span>
                </p>
                <div className="mt-6 flex items-center justify-between flex-wrap">
                  {VipFolderPlans.filter((p) => p.templates?.length).map((item) => (
                    <div
                      key={item.title}
                      className="rounded-md bg-gray-50 overflow-hidden mb-3 hover:shadow-lg hover:bg-white cursor-pointer"
                      style={{ width: '24%' }}
                      onClick={() => handleShowFolderDetail(item)}
                    >
                      <div className="p-2">
                        <h3 className="text-center font-bold text-xl">{item.title}</h3>
                        <h1 className="text-3xl text-center my-5 text-rose-700 mb-0 flex items-center justify-center">
                          ¥ {(item?.price - item?.off).toFixed(1)}
                          {item?.off && <p className="text-center text-xl text-neutral-400 line-through ml-2">¥ {item.price}</p>}
                        </h1>
                        <div className="mt-2 mb-4">
                          <p>将包含：{item?.desc?.[0]}</p>
                          {/* <div>
                          {item?.templates?.map((template) => (
                            <p>{template}</p>
                          ))}
                        </div> */}
                        </div>
                      </div>
                      <div className="text-center p-2 text-white cursor-pointer" style={{ backgroundColor: '#333' }}>
                        订阅 <ArrowRightOutlined />
                      </div>
                    </div>
                  ))}
                </div>
                <Drawer title={<h1 className="text-2xl">{activeFolder?.title}</h1>} onClose={() => setOpen(false)} width={500} open={open}>
                  <p className="text-lg mb-4">
                    本订阅库包含以下模版
                    {activeFolder?.total_value ? (
                      <span className="pl-4 text-yellow-600 font-bold text-2xl">总价值¥{activeFolder?.total_value}</span>
                    ) : (
                      <></>
                    )}
                  </p>
                  <div>
                    {templatesList?.map((item: any) => (
                      <Button
                        block
                        className="text-md font-bold mb-4 text-left"
                        icon={<EyeOutlined />}
                        onClick={() => handleActiveTemplate(item)}
                      >
                        {item?.title}
                      </Button>
                    ))}
                  </div>
                  <Button className="mt-4" type="primary" block onClick={() => setShowQRCode(true)}>
                    我要订阅
                  </Button>
                </Drawer>
              </div>
            </Badge.Ribbon>
          )}
        </div>
        <div className={isMobile ? 'w-full' : 'w-1/4'}>
          <Author email={true} />
          {/* <ol className="my-5 leading-8 list-decimal pl-8 text-base">
            <li>
              购买永久会员后可享受<strong className="text-blue-500">对应分类下的所有模版</strong>
            </li>
            <li>对于已购买过的付费模版不做折现返还</li>
            <li>加入永久会员后不支持退换</li>
          </ol> */}
          <Divider>订阅说明</Divider>
          <p className="p-2 text-neutral-400 text-center ">订阅价格以下单页面为准</p>
          <ul className="my-5 leading-8 list-disc pl-4">
            <li>对于已购买过的付费模版不做折现返还</li>
            <li>加入订阅后不支持退换</li>
            <li className="font-bold">模版库定价：本永久会员订阅采用阶梯式定价，随着模板数的增加定价会随之上升（不影响已订阅者）</li>
            <li>
              FlowUs订阅初始定价：<Tag color="red">¥99</Tag> 后面根据新增模板价值将<strong>不定期进行金额上调</strong>，上限不超过
              <Tag>¥199</Tag>。
            </li>
            <li>
              Notion模版库订阅初始定价：<Tag color="red">¥129</Tag> 后面根据新增模板价值将<strong>不定期进行金额上调</strong>，上限不超过
              <Tag>¥299</Tag>。
            </li>
            <li>知识库订阅包含不同分类的模版，可根据需要进行选择，每期订阅内不少于8个模版（定价以下单页面上价格为准）</li>
          </ul>
        </div>
      </Flex>
      <Modal
        width={320}
        centered
        closable={false}
        open={showQRCode}
        title={<div className="text-center">手机扫一扫加入我们吧！</div>}
        onCancel={() => setShowQRCode(false)}
        onOk={() => setShowQRCode(false)}
        okText="好的"
        cancelText="不了"
      >
        <Alert
          className="mb-4 text-center"
          type="warning"
          description={
            <>
              订阅前请仔细阅读<strong>订阅说明</strong>
              <p className="text-rose-800 font-bold">添加时请备注你需要的订阅内容</p>
            </>
          }
        />
        {/* <BuyCode /> */}
        <img src={wechatQrcode} />
      </Modal>
      <Modal
        width={1000}
        open={openTemplate}
        title={activeTemplate?.full_title || activeTemplate?.title}
        okText="直接单独购买"
        cancelText="关闭"
        onCancel={() => setOpenTemplate(false)}
        onOk={() => handleTemplateDetail(activeTemplate?.id)}
      >
        <Row className="pt-2">
          <Col span={8}>
            <Image src={activeTemplate?.cover} />
          </Col>
          <Col span={15} offset={1}>
            <p dangerouslySetInnerHTML={{ __html: activeTemplate?.detail }}></p>
          </Col>
        </Row>
      </Modal>
    </div>
    // </Spin>
  )
}
